import Promise from 'promise-polyfill'
import _ from 'lodash'

const Realization = {
  namespaced: true,
  mutations: {
    reset: (state, payload) => {
    }
  },
  actions: {
    getPagination: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization.getBtRealizationtAllUsingGET({page: payload.page})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getNewRealization: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization.addNewBtRealizationUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getEmployeeRealizationsByOrg: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.getBtRequestEmployeeToRealizationUsingGET({orgid: payload.orgid})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    addRealization: (context, payload) => {
      const vue = payload.vueinstance
      const sppdReal = _.cloneDeep(payload.sppdReal)
      sppdReal.expenses = []
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization.insertBtRealizationUsingPOST({sppdReal: sppdReal})
          .then(res => {
            // add expenses
            const realization = res.body
            if (sppdReal.sppdState !== 'CANCELED') {
              const expensePromises = payload.sppdReal.expenses.map(x => {
                const exp = x
                delete exp._tag
                return context.dispatch('addRealizationExpense',
                  {vueinstance: payload.vueinstance, id: realization.id, exp: x})
              })
              Promise.all(expensePromises)
                .then(res1 => {
                  realization.expenses = realization.expenses.concat(res1.map(x => x.body))
                  resolve(realization)
                })
                .catch(err => reject(err))
            } else {
              resolve(realization)
            }
          })
          .catch(err => reject(err))
      })
    },
    addRealizationExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealizationExpense.insertBtRealizationExpenseUsingPOST({id: payload.id, exp: payload.exp})
          .then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    getNewRealizationExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealizationExpense.addNewBtRealizationExpenseUsingGET()
          .then(res => {
            const expense = res.body
            expense._tag = {status: 'new'}
            resolve(expense)
          })
          .catch(err => reject(err))
      })
    },
    getEmployeeRealizationById: (context, payload) => {
      return new Promise((resolve, reject) => {
        context.dispatch('getEmployeeRealizationsByOrg', payload)
          .then(res => {
            const realization = res.find(x => parseInt(x.id) === parseInt(payload.id))
            if (typeof realization === 'undefined') {
              reject(new Error('Employee business trip request ' + payload.id + ' not found'))
            } else {
              resolve(realization)
            }
          })
          .catch(err => reject(err))
      })
    },
    deleteRealization: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization.deleteBtRealizationUsingDELETE({id: payload.id})
          .then(res => resolve()).catch(err => reject(err))
      })
    },
    getRealization: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization.getBtRealizationByIdUsingGET({id: payload.id})
          .then(res => {
            const realization = res.body
            // get expenses
            context.dispatch('getRealizationExpense', {vueinstance: payload.vueinstance, id: realization.content.id})
              .then(res1 => {
                realization.content.expenses = realization.content.expenses.concat(res1)
                resolve(realization)
              })
              .catch(err => reject(err))
          }).catch(err => reject(err))
      })
    },
    getRealizationExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealizationExpense.getBtRealizationExpenseUsingGET({id: payload.id})
          .then(res => {
            const expenses = res.body.map(x => {
              x._tag = {status: 'normal'}
              return x
            })
            resolve(expenses)
          })
          .catch(err => reject(err))
      })
    },
    updateRealization: (context, payload) => {
      const vue = payload.vueinstance
      const sppdReal = _.cloneDeep(payload.sppdReal)
      sppdReal.expenses = []
      const realizationPayload = {id: payload.id, sppdReal: sppdReal}
      if (!payload.transmode) {
        realizationPayload.transmode = payload.transmode
      }
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization.updateBtRealizationUsingPUT(realizationPayload)
          .then(res => {
            // update expenses
            const realization = res.body
            if (sppdReal.sppdState !== 'CANCELED') {
              const expensePromises = payload.sppdReal.expenses.map(x => {
                const exp = x
                const status = x._tag.status
                delete exp._tag

                if (status === 'new') {
                  return context.dispatch('addRealizationExpense',
                    {vueinstance: payload.vueinstance, id: realization.id, exp: exp})
                }
                if (status === 'update') {
                  return context.dispatch('updateRealizationExpense',
                    {vueinstance: payload.vueinstance, id: realization.id, expid: exp.id, exp: exp})
                } else if (status === 'delete') {
                  return context.dispatch('deleteRealizationExpense', {
                    vueinstance: payload.vueinstance, id: realization.id, expid: exp.id
                  })
                } else {
                  return new Promise((resolve) => resolve(exp))
                }
              })
              Promise.all(expensePromises)
                .then(res1 => {
                  context.dispatch('getRealizationExpense', {vueinstance: payload.vueinstance, id: realization.id})
                    .then(res2 => {
                      realization.expenses = realization.expenses.concat(res2)
                      resolve(realization)
                    }).catch(err => reject(err))
                }).catch(err => reject(err))
            } else {
              // delete all expenses
              context.dispatch('deleteAllRealizationExpense', {vueinstance: payload.vueinstance, id: realization.id})
                .then(res1 => { resolve(realization) }).catch(err => reject(err))
            }
          }).catch(err => reject(err))
      })
    },
    updateRealizationExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealizationExpense
          .updateBtRealizationExpenseUsingPUT({id: payload.id, expid: payload.expid, exp: payload.exp})
          .then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    deleteRealizationExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealizationExpense.deleteBtRealizationExpenseUsingDELETE({id: payload.id, expid: payload.expid})
          .then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    deleteAllRealizationExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealizationExpense.deleteBtRealizationExpenseBatchUsingDELETE({id: payload.id})
          .then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    generateRealizationExpense: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealizationExpense.generateBtRealizationExpenseUsingGET({sppdreal: payload.id,
          fromdate: payload.fromdate,
          todate: payload.todate,
          fromcity: payload.fromcity,
          tocity: payload.tocity})
          .then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    printLppd: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization.printBtRealizationLppdUsingGET({id: payload.id})
          .then(res => resolve(res.data)).catch(err => reject(err))
      })
    },
    filter: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.btRealization
          .getBtRealizationtAllFilterUsingGET({
            ds: payload.ds,
            impokey: payload.impokey,
            empkey: payload.empkey,
            fdate: payload.fdate,
            tdate: payload.tdate,
            batchno: payload.batchno,
            spstate: payload.spstate,
            page: payload.page,
            size: payload.size
          }).then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    reset: (context, payload) => {
      context.commit('reset', payload)
    }
  }
}

export default Realization



// WEBPACK FOOTER //
// ./src/store/btrealization/Realization.js